import { render, staticRenderFns } from "./InitiateEvaluation.vue?vue&type=template&id=67fdbb6d"
import script from "./initiate-evaluation.ts?vue&type=script&lang=ts&external"
export * from "./initiate-evaluation.ts?vue&type=script&lang=ts&external"
import style0 from "./initiate-evaluation.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports